import { InheritanceTrust } from "@prisma/client-generated";
import { z } from "zod";

export const inheritanceAndTrustSchemaCreate = z.object({
  category: z.nativeEnum(InheritanceTrust),
  nameOfTrust: z.string(),
  benefactor: z.string().nullish(),
  description: z.string().nullish(),
  valueInCents: z.number().min(0),
  currency: z.string().nullish(),
});

export const inheritanceAndTrustSchemaUpdate =
  inheritanceAndTrustSchemaCreate.partial();
